export default __webpack_public_path__ + "static/media/dribbble.14f7ff50.svg";